export default {
  // 全球英语：待定
  xxxx: {
    ad1: [],
    ad2: [],
  },
  // 全球英语 语言 + 国家
  get en_gl() {
    return this["hi"];
  },
  // 印度英语 语言 + 国家
  get en_in() {
    return this["en"];
  },
  // 印尼语 语言 + 国家
  get id_id() {
    return this["id"];
  },
  // 印度印地语 语言 + 国家
  get hi_in() {
    return this["hi"];
  },
  // 印度英语
  en: {
    ad1: [
      {
        type: "adx",
        id: "div-gpt-ad-1749106076968-0",
        slot: "/23161678951/v_ls_disnews_comfortweather_20250602_320x100_1",
        rect: [320, 100],
        style: {
          minWidth: "320px",
          minHeight: "100px",
        },
        position: "position-08",
      },
      {
        // type: "adx",
        // id: "div-gpt-ad-1749106106007-0",
        // slot: "/23161678951/v_ls_disnews_comfortweather_20250602_320x100_2",
        // rect: [320, 100],
        // style: {
        //   minWidth: "320px",
        //   minHeight: "100px",
        // },

        type: "anchor",
        slot: "/23161678951/v_ls_disnews_comfortweather_20250602_320x100_2",

        position: "position-01",
      },
    ],
    ad2: [
      {
        type: "adx",
        id: "div-gpt-ad-1749106134768-0",
        slot: "/23161678951/v_ls_disnews_comfortweather_20241031_320x250_1",
        rect: [320, 250],
        style: {
          minWidth: "320px",
          minHeight: "250px",
        },
        position: "position-30",
      },
      {
        type: "adx",
        id: "div-gpt-ad-1749106159614-0",
        slot: "/23161678951/v_ls_disnews_comfortweather_20241031_320x250_2",
        rect: [320, 250],
        style: {
          minWidth: "320px",
          minHeight: "250px",
        },
        position: "position-31",
      },
      {
        type: "adx",
        id: "div-gpt-ad-1749106183749-0",
        slot: "/23161678951/v_ls_disnews_comfortweather_20241031_320x250_3",
        rect: [320, 250],
        style: {
          minWidth: "320px",
          minHeight: "250px",
        },
        position: "position-32",
      },
      {
        type: "adx",
        id: "div-gpt-ad-1749106210224-0",
        slot: "/23161678951/v_ls_disnews_comfortweather_20241031_320x250_4",
        rect: [320, 250],
        style: {
          minWidth: "320px",
          minHeight: "250px",
        },
        position: "position-33",
      },
    ],
  },
  // 印地语
  hi: {
    ad1: [
      {
        type: "adx",
        id: "div-gpt-ad-1749277772531-0",
        slot: "/23161678951/v_ls_disnews_en_comfortweather_20250602_320x100_1",
        rect: [320, 100],
        style: {
          minWidth: "320px",
          minHeight: "100px",
        },
        position: "position-08",
      },
      {
        // type: "adx",
        // id: "div-gpt-ad-1749277799675-0",
        // slot: "/23161678951/v_ls_disnews_en_comfortweather_20250602_320x100_2",
        // rect: [320, 100],
        // style: {
        //   minWidth: "320px",
        //   minHeight: "100px",
        // },

        type: "anchor",
        slot: "/23161678951/v_ls_disnews_en_comfortweather_20250602_320x100_2",

        position: "position-01",
      },
    ],
    ad2: [
      {
        type: "adx",
        id: "div-gpt-ad-1749277825688-0",
        slot: "/23161678951/v_ls_disnews_en_comfortweather_20250602_320x250_1",
        rect: [320, 250],
        style: {
          minWidth: "320px",
          minHeight: "250px",
        },
        position: "position-30",
      },
      {
        type: "adx",
        id: "div-gpt-ad-1749277851490-0",
        slot: "/23161678951/v_ls_disnews_en_comfortweather_20250602_320x250_2",
        rect: [320, 250],
        style: {
          minWidth: "320px",
          minHeight: "250px",
        },
        position: "position-31",
      },
      {
        type: "adx",
        id: "div-gpt-ad-1749277876670-0",
        slot: "/23161678951/v_ls_disnews_en_comfortweather_20250602_320x250_3",
        rect: [320, 250],
        style: {
          minWidth: "320px",
          minHeight: "250px",
        },
        position: "position-32",
      },
      {
        type: "adx",
        id: "div-gpt-ad-1749277900242-0",
        slot: "/23161678951/v_ls_disnews_en_comfortweather_20250602_320x250_4",
        rect: [320, 250],
        style: {
          minWidth: "320px",
          minHeight: "250px",
        },
        position: "position-33",
      },
    ],
  },
  // 印尼语
  id: {
    ad1: [
      {
        type: "adx",
        id: "div-gpt-ad-1749122052206-0",
        slot: "/23161678951/v_ls_disnews_id_comfortweather_20250602_320x100_1",
        rect: [320, 100],
        style: {
          minWidth: "320px",
          minHeight: "100px",
        },
        position: "position-08",
      },
      {
        // type: "adx",
        // id: "div-gpt-ad-1749122082215-0",
        // slot: "/23161678951/v_ls_disnews_id_comfortweather_20250602_320x100_2",
        // rect: [320, 100],
        // style: {
        //   minWidth: "320px",
        //   minHeight: "100px",
        // },

        type: "anchor",
        slot: "/23161678951/v_ls_disnews_id_comfortweather_20250602_320x100_2",

        position: "position-01",
      },
    ],
    ad2: [
      {
        type: "adx",
        id: "div-gpt-ad-1749122109325-0",
        slot: "/23161678951/v_ls_disnews_id_comfortweather_20250602_320x250_1",
        rect: [320, 250],
        style: {
          minWidth: "320px",
          minHeight: "250px",
        },
        position: "position-30",
      },
      {
        type: "adx",
        id: "div-gpt-ad-1749122134550-0",
        slot: "/23161678951/v_ls_disnews_id_comfortweather_20250602_320x250_2",
        rect: [320, 250],
        style: {
          minWidth: "320px",
          minHeight: "250px",
        },
        position: "position-31",
      },
      {
        type: "adx",
        id: "div-gpt-ad-1749122574334-0",
        slot: "/23161678951/v_ls_disnews_id_comfortweather_20250602_320x250_3",
        rect: [320, 250],
        style: {
          minWidth: "320px",
          minHeight: "250px",
        },
        position: "position-32",
      },
      {
        type: "adx",
        id: "div-gpt-ad-1749122603089-0",
        slot: "/23161678951/v_ls_disnews_id_comfortweather_20250602_320x250_4",
        rect: [320, 250],
        style: {
          minWidth: "320px",
          minHeight: "250px",
        },
        position: "position-33",
      },
    ],
  },
  get in() {
    return this["id"];
  },
  get in_id() {
    return this["id"];
  },
};
